import React, { useState } from 'react';
import './Row.css';
import '../../pages/Dashboards/MoreSelectionMenu.css';
import postgresLogo from '../../assets/images/integrations/postgres.png';
import quickbooksLogo from '../../assets/images/integrations/quickbooks.png';
import excelLogo from '../../assets/images/integrations/excel.png';
import { ReactComponent as MoreIcon } from '../../assets/icons/more-icon.svg';
import { ReactComponent as EditIcon } from '../../assets/icons/edit-icon.svg';
import { ReactComponent as DeleteIcon } from '../../assets/icons/delete-icon.svg';
const Row = ({dataSourceData, userId, handleEditDataSource, handleDeleteDataSource}) => {

    const [moreSelectionOpen, setMoreSelectionOpen] = useState(false);


    const formatDate = (date) => {
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        const d = new Date(date).toLocaleDateString(undefined, options);
        return d;
    };

    // Mapping of data source types to image URLs
    const typeImages = {
        "PostgreSQL": postgresLogo,
        "QuickBooks": quickbooksLogo,
        "Excel": excelLogo
    };

    const getAccessType = () => {
        if (dataSourceData.accessType === 'private') {
            return 'Private';
        } else {
            return 'Team-Wide';
        }
    }

    const getFormattedStatus = (status) => {
        switch (status) {
            case 'ready':
                return 'Ready';
            case 'syncing':
                return dataSourceData.dataSourceType === 'Excel' ? 'Uploading' : 'Syncing';
            case 'sync-failed':
                return dataSourceData.dataSourceType === 'Excel' ? 'Upload Failed' : 'Sync Failed';
            case 'disconnected':
                return dataSourceData.dataSourceType === 'Excel' ? 'Not Uploaded' : 'Not Connected';
            case 'not-synced':
                return dataSourceData.dataSourceType === 'Excel' ? 'Not Uploaded' : 'Not Synced';
            default:
                return status.charAt(0).toUpperCase() + status.slice(1);
        }
    };

    const renderMoreSelection = () => (
        <div className="more-selection-menu">
            <div className="more-option" onClick={(event) => {
                event.stopPropagation();
                setMoreSelectionOpen(false);
                handleEditDataSource(dataSourceData);
            }}>
                <EditIcon className="more-option-icon" />
                <span>Edit Source</span>
            </div>
            <div className="more-option delete" onClick={(event) => {
                event.stopPropagation();
                setMoreSelectionOpen(false);
                handleDeleteDataSource(dataSourceData.id);
            }}>
                <DeleteIcon className="more-option-icon" />
                <span>Delete Source</span>
            </div>
        </div>
    );

    return (
        <tr 
            className="data-source-row" 
            onMouseLeave={() => setMoreSelectionOpen(false)}
            onClick={() => handleEditDataSource(dataSourceData)}
        >
            <td className="connection-name">{dataSourceData.name}</td>
            <td>
                {dataSourceData.dataSourceType ? (
                    <div className="datasource-type">
                        <img src={typeImages[dataSourceData.dataSourceType]} alt={dataSourceData.dataSourceType} />
                        <p>{dataSourceData.dataSourceType}</p>
                    </div>
                ) : (
                    <div className="datasource-type no-type">
                        <p>None</p>
                    </div>
                )}
            </td>
            <td>{formatDate(dataSourceData.createdAt)}</td>
            <td>
                <div className={`role-container ${dataSourceData.creatorUserId === userId ? 'owner' : 'collaborator'}`}>
                    <p>{dataSourceData.creatorUserId === userId ? 'Owner' : 'Collaborator'}</p>
                </div>
            </td>
            <td>{getAccessType()}</td>
            <td>
                <div className={`status-container ${dataSourceData.status}`}>
                    {dataSourceData.status === "syncing" && <div className="syncing-spinner"></div>}
                    <span>{getFormattedStatus(dataSourceData.status)}</span>
                </div>
            </td>
            <td className="more-column">
                <div className="more-container">
                    <MoreIcon className="more-icon" onClick={(event) => {
                        event.stopPropagation();
                        setMoreSelectionOpen(!moreSelectionOpen)
                    }}/>
                    {moreSelectionOpen && renderMoreSelection()}
                </div>
            </td>
        </tr>
    );
};

export default Row;